export default {
    NOTIFICATION_TYPE: 'mobileInterstitial',
    ITUNES_LINK: 'https://itunes.apple.com/us/app/1stdibs/id938157117',
    FULLSCREEN_NAME: 'fullscreen',
    MC_APP_BANNER: 'messageCenterAppBanner',
    FULLSCREEN_GA_ACTION: 'app interstitial - full screen on second page',
};



// WEBPACK FOOTER //
// ./src/mobileAds/constants.js